import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1585.96251,1920 L960.481253,1544.71125 L335,1920 L335,170.585796 C335,76.5361606 411.536161,0 505.585796,0 L1415.37671,0 C1509.42635,0 1585.96251,76.5361606 1585.96251,170.585796 L1585.96251,1920 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconBookmarkSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconBookmarkSolid, _Component);

  var _super = _createSuper(IconBookmarkSolid);

  function IconBookmarkSolid() {
    _classCallCheck(this, IconBookmarkSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconBookmarkSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconBookmark",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconBookmarkSolid.displayName = "IconBookmarkSolid";
  return IconBookmarkSolid;
}(Component);

IconBookmarkSolid.glyphName = 'bookmark';
IconBookmarkSolid.variant = 'Solid';
IconBookmarkSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconBookmarkSolid;
export { IconBookmarkSolid };